export * from './customer-portal-ui.module';
export * from './customer-portal-admin-ui.module';
export * from './models';
export * from './services';
export * as cpTypes from './models/consumer-portal-config';
export { DepotTimezoneDateFormat } from './enums/depot-timezone-date-format.enum';
export { CustomerPortalComponent } from './components/customer-portal/customer-portal.component';
export { CustomerPortalAdminComponent } from './admin/components/admin/admin.component';
export * from './languages';
export * from './constants/default.const';

import * as enUSTranslations from '../assets/en-US.json';
import * as enGBTranslations from '../assets/en-GB.json';
import * as frCATranslations from '../assets/fr-CA.json';

export const ConsumerPortalLanguage = {
    enUSTranslations,
    enGBTranslations,
    frCATranslations
};
